import { useOnKeyDown as h } from "@placer-ui/hooks";
import { useState as k, useCallback as T } from "react";
const B = ({
  ref: m,
  originalProps: e
}) => {
  const [M, c] = k(!1);
  h((u) => {
    u.key === "Tab" && c(!1);
  }, m == null ? void 0 : m.current);
  const O = T(
    (u) => {
      var t;
      c(!0), (t = e == null ? void 0 : e.onMouseEnter) == null || t.call(e, u);
    },
    [e]
  ), f = T(
    (u) => {
      var t;
      c(!1), (t = e == null ? void 0 : e.onMouseLeave) == null || t.call(e, u);
    },
    [e]
  ), E = T(
    (u) => {
      var t;
      c(!1), (t = e == null ? void 0 : e.onBlur) == null || t.call(e, u);
    },
    [e]
  ), b = T(
    (u) => {
      var t;
      c(!0), (t = e == null ? void 0 : e.onFocus) == null || t.call(e, u);
    },
    [e]
  );
  return {
    isTooltipOpen: M,
    enrichTooltipProps: {
      onMouseEnter: O,
      onMouseLeave: f,
      onFocus: b,
      onBlur: E
    }
  };
};
export {
  B as useEnrichTooltipOpenState
};
//# sourceMappingURL=index.es128.js.map
